import React from 'react';
import { useTranslation } from 'react-i18next';

import { NAMESPACE } from '@app/i18n';
import { Button } from '@chakra-primitives/button';

import styles from './ErrorSplashScreen.module.less';
import MarleyIcon from '../icons/MarleyIcon';

const ErrorSplashScreen = () => {
  const { t } = useTranslation(NAMESPACE.APP_SHELL);

  const handleClickBackToHome = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    window.location.href = '/';
  };

  return (
    <div className={styles['splash-screen']}>
      <div className={styles.logo}>
        <MarleyIcon />
      </div>
      <div className={styles.body}>
        <div className={`${styles.message} ${styles.error}`}>
          {t('error.message')}
        </div>
        <Button data-testid="back-to-home" onClick={handleClickBackToHome}>
          {t('error.backToHome')}
        </Button>
      </div>
    </div>
  );
};

export default ErrorSplashScreen;
